import React from 'react';
import { RatingBox } from '../../../common/components/rating-box';
import { IHSRTierNode } from '../../../common/model/graphql-types';
import {
  faHandFist,
  faVirus,
  faFlask,
  faBriefcaseMedical
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
  character: IHSRTierNode;
}

export const HSRPopoverRatings: React.FC<IProps> = ({ character }) => {
  return (
    <>
      {character.slug === 'argenti' ? (
        <p className="hsr-role">
          This character can be played in multiple roles and below we only show
          ratings for the{' '}
          <span className="role debuffer">
            <FontAwesomeIcon icon={faVirus} width="12" /> Support DPS
          </span>{' '}
          role. For others, check the profile.
        </p>
      ) : (
        <>
          {' '}
          <p className="hsr-role">
            This character belongs to the{' '}
            {character.cat === 'DPS' && (
              <span className="role dps">
                <FontAwesomeIcon icon={faHandFist} width="12" /> DPS
              </span>
            )}
            {character.cat === 'Specialist' && (
              <span className="role debuffer">
                <FontAwesomeIcon icon={faVirus} width="12" /> Support DPS
              </span>
            )}
            {character.cat === 'Amplifier' && (
              <span className="role support">
                <FontAwesomeIcon icon={faFlask} width="12" /> Amplifier
              </span>
            )}
            {character.cat === 'Sustain' && (
              <span className="role sustain">
                <FontAwesomeIcon icon={faBriefcaseMedical} width="12" /> Sustain
              </span>
            )}{' '}
            role and the ratings rate their performance at this role only.
          </p>
        </>
      )}

      {character.rarity === 5 || character.slug === 'march-7th-swordmaster' ? (
        <>
          {character.slug === 'trailblazer-destruction' ||
          character.slug === 'trailblazer-harmony' ||
          character.slug === 'march-7th-swordmaster' ||
          character.slug === 'trailblazer-preservation' ||
          character.slug === 'trailblazer-remembrance' ? (
            <div className="bottom rev three with-margin">
              {character.slug === 'trailblazer-remembrance' ? (
                <>
                  <RatingBox
                    game="hsr"
                    rating={character.moc_rating}
                    ratingName="MoC (E0)"
                  />
                  <RatingBox
                    game="hsr"
                    rating={character.pure_rating}
                    ratingName="PF (E0)"
                  />
                  <RatingBox
                    game="hsr"
                    rating={character.apo_rating}
                    ratingName="AS (E0)"
                  />
                </>
              ) : (
                <>
                  <RatingBox
                    game="hsr"
                    rating={character.moc_rating}
                    ratingName="MoC (E6)"
                  />
                  <RatingBox
                    game="hsr"
                    rating={character.pure_rating}
                    ratingName="PF (E6)"
                  />
                  <RatingBox
                    game="hsr"
                    rating={character.apo_rating}
                    ratingName="AS (E6)"
                  />
                </>
              )}
            </div>
          ) : (
            <div className="bottom rev three">
              <>
                <RatingBox
                  game="hsr"
                  rating={character.moc_rating}
                  ratingName="MoC (E0S0)"
                />
                <RatingBox
                  game="hsr"
                  rating={character.pure_rating}
                  ratingName="PF (E0S0)"
                />
                <RatingBox
                  game="hsr"
                  rating={character.apo_rating}
                  ratingName="AS (E0S0)"
                />
              </>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="bottom rev three with-margin">
            <RatingBox
              game="hsr"
              rating={character.moc_special_rating}
              ratingName="MoC (E0)"
            />
            <RatingBox
              game="hsr"
              rating={character.pure_special_rating}
              ratingName="PF (E0)"
            />
            <RatingBox
              game="hsr"
              rating={character.apo_special_rating}
              ratingName="AS (E0)"
            />
          </div>
          <div className="bottom rev three">
            <RatingBox
              game="hsr"
              rating={character.moc_rating}
              ratingName="MoC (E6)"
            />
            <RatingBox
              game="hsr"
              rating={character.pure_rating}
              ratingName="PF (E6)"
            />
            <RatingBox
              game="hsr"
              rating={character.apo_rating}
              ratingName="AS (E6)"
            />
          </div>
        </>
      )}
    </>
  );
};
